import DOMPurify from 'dompurify'

// Toda string renderizada com dangerouslySetInnerHTML deve passar por aqui.
export default (html) => DOMPurify.sanitize(html)
